var map = {
	"./arrow-right.svg": 488,
	"./blue-loader.svg": 118,
	"./book-open.svg": 203,
	"./dropdown.svg": 489,
	"./ethereum-logo.png": 206,
	"./menu.svg": 490,
	"./metamask.png": 259,
	"./shopping-bag.svg": 201,
	"./tag.svg": 202
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 180;